<template>
  <div style="width: 100%; display: flex; justify-content: center;">
    <v-chart :options="options" :theme="tema"/>
  </div>
</template>

<style>
.echarts {
  width: 250px;
  height: 250px;
}
</style>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import themeessos from '@/assets/themes/essos.js' // Caminho para o arquivo de tema
import themeroma from '@/assets/themes/roma.js' // Caminho para o arquivo de tema
import themevintage from '@/assets/themes/vintage.js' // Caminho para o arquivo de tema
import themewesteros from '@/assets/themes/westeros.js' // Caminho para o arquivo de tema

export default {
  name: "cmpgraficodoughnut",
  components: {
    'v-chart': ECharts
  },
  props: [
    'rotulo',
    'legendas',
    'dados',
    'tema'
  ],
  data() {
    return {
      options: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: -5,
          top: '30',
          data: [],
          textStyle: {
            fontSize: 8
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['35%', '65%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      }
    }
  },
  mounted() {
    

    switch (this.tema) {
        case 'essos':
            ECharts.registerTheme('essos', themeessos);
            break;
        case 'roma':
            ECharts.registerTheme('roma', themeroma);
            break;
        case 'vintage':
            ECharts.registerTheme('vintage', themevintage);
            break;
        case 'westeros':
            ECharts.registerTheme('westeros', themewesteros);
            break;         
    }
   
  },
  watch: {
    legendas() {
      this.options.legend.data = this.legendas;
      this.options.series[0].name = this.rotulo;
      this.options.series[0].data = this.dados;
    }
  }
}
</script>
